import { render } from "./packing-stuff.svg?vue&type=template&id=68436288"
const script = {}

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__